import React from 'react';
import '../../admin-stats.css';

function UserStatsChart({ userData, loading }) {
  if (loading || !userData) {
    return (
      <div className="stats-section">
        <h2>User Statistics</h2>
        <div className="loading">Loading user data...</div>
      </div>
    );
  }

  const stats = userData;

  return (
    <div className="stats-section">
      <h2>👥 User Statistics</h2>
      
      <div className="stats-grid">
        <div className="stat-box">
          <h3>By Role</h3>
          <div className="breakdown-list">
            {stats.byRole && Object.entries(stats.byRole).map(([role, data]) => (
              <div key={role} className="breakdown-item">
                <span className="label">{role}</span>
                <span className="value">{data.count}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="stat-box">
          <h3>Activity Level</h3>
          <div className="breakdown-list">
            {stats.activityLevel && (
              <>
                <div className="breakdown-item">
                  <span className="label">Very Active</span>
                  <span className="value positive">{stats.activityLevel.veryActive?.count || 0}</span>
                </div>
                <div className="breakdown-item">
                  <span className="label">Somewhat Active</span>
                  <span className="value">{stats.activityLevel.somewhatActive?.count || 0}</span>
                </div>
                <div className="breakdown-item">
                  <span className="label">Inactive</span>
                  <span className="value warning">{stats.activityLevel.inactive?.count || 0}</span>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="stat-box">
          <h3>Registration Trends</h3>
          <div className="breakdown-list">
            <div className="breakdown-item">
              <span className="label">This Month</span>
              <span className="value">{stats.registrationTrends?.thisMonth || 0}</span>
            </div>
            <div className="breakdown-item">
              <span className="label">Last Month</span>
              <span className="value">{stats.registrationTrends?.lastMonth || 0}</span>
            </div>
            <div className="breakdown-item">
              <span className="label">Growth Rate</span>
              <span className={`value ${stats.registrationTrends?.growthRate > 0 ? 'positive' : 'negative'}`}>
                {stats.registrationTrends?.growthRate || 0}%
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="stat-box full-width">
        <h3>Top Contributors</h3>
        {stats.topContributors && stats.topContributors.length > 0 ? (
          <div className="table-container">
            <table className="stats-table">
              <thead>
                <tr>
                  <th>Display Name</th>
                  <th>Post Count</th>
                </tr>
              </thead>
              <tbody>
                {stats.topContributors.map((contributor, idx) => (
                  <tr key={idx}>
                    <td>{contributor.displayName}</td>
                    <td className="text-right">{contributor.postCount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="empty-state">No contributors yet</p>
        )}
      </div>

      {stats.timeSeries && stats.timeSeries.length > 0 && (
        <div className="stat-box full-width">
          <h3>Registration Timeline</h3>
          <div className="timeline-container">
            {stats.timeSeries.map((item, idx) => (
              <div key={idx} className="timeline-item">
                <span className="timeline-date">{item.date}</span>
                <span className="timeline-value">{item.newUsers} new</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default UserStatsChart;
